<template>
  <h-list-page class="SQMList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" is-search @change-method="changeMethod">
      <h-area>
      <!-- 
        <h-search title="模块商代码" v-if="dataFrom">
          <h-autocomplete popper-class="planHidden" v-model="searchData.modelNo" :fetch-suggestions="supplyCodeChange"
            :trigger-on-focus="false" @input="() =>
              searchData.modelNo.length < 2 ? (showSupplyPlan = false) : ''" @clear="showSupplyPlan = false" clearable
            placeholder="请输入至少两位模块商代码" @blur="detailBlur('showSupplyPlan')" @focus="detailFocus('showSupplyPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0">
            <el-table v-show="showSupplyPlan" v-loading="supplyLoading" :data="supplyCodeList" border size="small"
              max-height="252" @row-click="clickSupplierCode" @mousedown="planBlur = true">
              <el-table-column prop="supplyCode" label="模块商代码" width="120"></el-table-column>
              <el-table-column prop="supplyName" label="模块商名称"></el-table-column>
            </el-table>
            <div v-if="showSupplyPlan && SupplyOver600" style="
                color: red;
                height: 20px;
                background-color: #fff;
                padding-top: 3px;
              ">
              <span style="padding-left: 10px; font-size: 12px">注：仅查询600条数据，如无所需结果，请输入更精确的模块商代码</span>
            </div>
          </h-detail>
        </h-search>

        <h-search title="模块商名称" v-if="dataFrom">
          <h-input v-model="searchData.modelName" clearable @change="changeNull(searchData.modelName, 'modelName')">
          </h-input>
        </h-search>

        <h-search title="专用号">
          <h-autocomplete popper-class="planHidden" v-model="searchData.prodNo" :fetch-suggestions="mtlNoChange"
            :trigger-on-focus="false" @input="() =>
              searchData.prodNo.length < 4 ? (showMtlPlan = false) : ''" @clear="showMtlPlan = false" clearable
            placeholder="请输入至少四位专用号" @blur="detailBlur('showMtlPlan')" @focus="detailFocus('showMtlPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="showMtlPlan" v-loading="mtlLoading" :data="mtlNoList" border size="small" max-height="252"
              @row-click="clickMtlNo" @mousedown="planBlur = true">
              <el-table-column prop="mtlNo" label="物料号" width="120"></el-table-column>
              <el-table-column prop="mtlName" label="物料名称"></el-table-column>
            </el-table>
            <div v-if="showMtlPlan && MtlOver600" style="color: red;height: 20px;background-color: #fff;
                padding-top: 3px;">
              <span style="padding-left: 10px; font-size: 12px">注：仅查询600条数据，如无所需结果，请输入更精确的物料号</span>
            </div>
          </h-detail>
        </h-search>

        <h-search title="物料名称">
          <h-input v-model="searchData.prodName" clearable @change="changeNull(searchData.prodName, 'prodName')">
          </h-input>
        </h-search>
      -->
        <h-search :title="h_i18n('d9bcdd40b55107e97b9881d6e476bb20')">
          <h-input v-model="searchData.uniqueCode" clearable @change="changeNull(searchData.uniqueCode, 'uniqueCode')">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('62eadaf8a7896d1d8cad08ee4131b959')">
          <h-input v-model="searchData.qrCode" clearable @change="changeNull(searchData.qrCode, 'qrCode')">
          </h-input>
        </h-search>
        <!--
        <h-search title="检测项目">
          <h-input v-model="searchData.onlineTestProject" clearable @change="changeNull(searchData.onlineTestProject, 'onlineTestProject')">
          </h-input>
        </h-search>

        <h-search title="生产批次">
          <h-input v-model="searchData.prodBatch" clearable @change="changeNull(searchData.prodBatch, 'prodBatch')">
          </h-input>
        </h-search>

        <h-search title="生产工厂全称">
          <h-input v-model="searchData.produceFacFullName" clearable
            @change="changeNull(searchData.produceFacFullName, 'produceFacFullName')">
          </h-input>
        </h-search>

        <h-search title="生产地址">
          <h-input v-model="searchData.adress" clearable @change="changeNull(searchData.adress, 'adress')">
          </h-input>
        </h-search>

        <h-search title="检测结果">
          <h-input v-model="searchData.testResult" clearable @change="changeNull(searchData.testResult, 'testResult')">
          </h-input>
        </h-search>

        <h-search title="检测时间">
          <h-date-picker @change="TimeChange(searchData.testTime, { start: 'testTimeStart', end: 'testTimeEnd' })"
            v-model="searchData.testTime" type="daterange" start-placeholder="开始" end-placeholder="结束"
            :clearable="clearAble" />
        </h-search>
-->
        <template #operate>
          <h-button type="primary" :loading="this.loading" @click="handleCurrentChange(1)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('74b2e64aae927a7572c3f7bdcb3f084d')" :is-left="0" :is-right="0" :h-data="tableData">
      <template #buttonGroup>
      <h-button-group>
        <!-- 导出 -->
        <h-button :loading="exportLoading" type="primary" @click="EXportsqm">
          <template #icon>
            <i class="iconfont icon-daochu"></i>
          </template>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
        <div class="tipBox_yellow">
            <img src="@/assets/img/tips-icon.png" class="tip-img" />{{ h_i18n('6fce02a38267ac7ce89e3add5eeb1bae') }}</div>
        <!-- <div v-show="!dataFrom" style="text-wrap:nowrap;color:#165dff;padding-left: 20px;">
          （默认展示检测开始日期1个月之内的数据，可选择查询条件查询更多数据）</div> -->
      </h-button-group>
      </template>

      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" @current-change="clickrow" highlight-current-row
                  :data="tableData" size="small" border height="540" style="width: 100%;min-height: 540px">
            <!-- <el-table-column v-if="dataFrom" prop="modelNo" label="模块商代码" width="90"
            ></el-table-column>
            <el-table-column v-if="dataFrom" prop="modelName" label="模块商名称" width="200"
            ></el-table-column> -->
            <el-table-column prop="prodNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130"></el-table-column>
            <el-table-column prop="prodName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" min-width="200">
                <template #default="scope">
                    <div style="text-align:left">{{ scope.row.prodName }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="produceFacFullName" :label="h_i18n('4fe28e7de0d2d2138a5fcdd9869bd281')" width="180"></el-table-column>
            <el-table-column prop="adress" :label="h_i18n('6e3ef2295870257f741434e2f8cf646b')" width="180"></el-table-column>
            <el-table-column prop="prodBatch" :label="h_i18n('13b062af2976411b3f19c9820febe842')" width="160"></el-table-column>
            <el-table-column prop="lineCode" :label="h_i18n('24d6c9b03ed096d69b753505d691e3c4')" width="100"></el-table-column>
            <el-table-column prop="uniqueCode" :label="h_i18n('d9bcdd40b55107e97b9881d6e476bb20')" width="180"></el-table-column>
            <el-table-column prop="qrCode" :label="h_i18n('62eadaf8a7896d1d8cad08ee4131b959')" width="180"></el-table-column>
            <el-table-column prop="testTime" :label="h_i18n('44c4227175922c94497714edab9db531')" width="150"></el-table-column>
            <el-table-column prop="onlineTestProject" :label="h_i18n('22ec1277cd9a5f08ea93ec8aee06911b')" width="100"></el-table-column>
            <el-table-column prop="testResult" :label="h_i18n('77b9b1d1720981ebe160fd67cdd61db9')" width="100">
              <template #default="{ row }">
            <span v-if="row.testResult == '合格'" style="color: #70B60C;">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
            <span v-else-if="row.testResult == '不合格'" style="color: #d74c4d;">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
            <span v-else>{{ row.testResult }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        v-model:currentPage="pagenation.pageNo" :page-size="pagenation.pageSize" layout="total, prev, pager, next,jumper"
        :total="total">
      </el-pagination>

    </h-table-card>
  </h-list-page>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import axios from "axios";
    export default {
        name: 'QueryDetails',
        data() {
            return {
                expents: false,
                pagenation: {
                    pageNo: 1,
                    pageSize: 10,
                },
                tableData: [],
                total: 0,
                modelNo: '',
                prodBatch: '',
                prodNo: '',
                roleType: '',
                searchData: {
                    testTimeStart: undefined,
                    testTimeEnd: undefined,
                    prodNo:undefined,
                    modelNo:undefined,
                },
                loading: false,
                // dataFrom: true,
                isOne: true,
                name: '',
                exportBtnCodeOfHac:'S01053_GCZXJC_DC',
                mtlLoading: false,
                showMtlPlan: false,
                planBlur: false,
                MtlOver600: false,
                SupplyOver600: false,
                showSupplyPlan: false,
                mtlSearchHttp: false,
                supplySearchHttp: false,
                mtlNoList: [],
                supplyCodeList: [],
                buttonList: [],
                exportLoading: false,

            }
        },
        methods: {
    h_i18n,
           /**
     * 传高度
     */
    changeMethod() {
      this.postThisPageHeight();
    },
    // 按钮公共处理函数
    // loading事件
    loadingEvent(code) {
      switch (code) {
        case this.exportBtnCodeOfHac:
          return this.exportLoading;
        default:
          return null;
      }
    },

    // input为空时undefined
    changeNull(value, key) {
      if (value === "") {
        this.searchData[key] = undefined;
      }
    },

    // 弹窗失焦
    detailBlur(v) {
      if (!this.planBlur) {
        this[v] = false;
      }
    },
    // 弹窗聚焦
    detailFocus(v) {
      this.planBlur = false;
      if (v == "showSupplyPlan") {
        if (this.searchData.modelNo.length >= 2) {
          this[v] = true;
        }
      } else if (v == "showMtlPlan") {
        if (this.searchData.prodNo.length >= 4) {
          this[v] = true;
        }
      }
    },
    clickMtlNo(row) {
      this.searchData.prodNo = row.mtlNo;
      this.showMtlPlan = false;
    },
    clickSupplierCode(row) {
      this.searchData.modelNo = row.supplyCode;
      this.showSupplyPlan = false;
    },
    /**
     * 专用号模糊查询
     */
    mtlNoChange() {
      this.planBlur = false;
      if (this.mtlSearchHttp) this.mtlSearchHttp.cancel();
      this.mtlSearchHttp = axios.CancelToken.source();
      if (this.searchData.prodNo.length < 4) {
        this.showMtlPlan = false;
      } else {
        this.showMtlPlan = true;
        this.mtlLoading = true;
        this
          .$http({
            method: "POST",
            url: "/base/basicData/searchMaterielList",
            headers: { "content-type": "application/json" },
            data: {
              mtlNo: this.searchData.prodNo,
            },
            cancelToken: this.mtlSearchHttp.token,
          })
          .then((res) => {
            this.mtlNoList = res.data.data;
            if (this.mtlNoList.length >= 600) {
              this.MtlOver600 = true;
              this.mtlLoading = false;
            } else {
              this.MtlOver600 = false;
              this.mtlLoading = false;
            }
          })
          .catch((e) => { });
      }
    },
    /**
     * 供应商模糊查询
     */
    supplyCodeChange() {
      this.planBlur = false;
      if (this.supplySearchHttp) this.supplySearchHttp.cancel();
      this.supplySearchHttp = axios.CancelToken.source();
      if (this.searchData.modelNo.length < 2) {
        this.showSupplyPlan = false;
      } else {
        this.showSupplyPlan = true;
        this.supplyLoading = true;
        this
          .$http({
            method: "post",
            url: "/base/basicData/searchSupplierList",
            headers: { "content-type": "application/json" },
            data: {
              supplyCode: this.searchData.modelNo,
            },
            cancelToken: this.supplySearchHttp.token,
          })
          .then((res) => {
            this.supplyCodeList = res.data.data;
            if (this.supplyCodeList.length >= 600) {
              this.SupplyOver600 = true;
              this.supplyLoading = false;
            } else {
              this.SupplyOver600 = false;
              this.supplyLoading = false;
            }
          })
          .catch((e) => { });
      }
    },
    // 两个模糊查询结束


    // 时间范围选择
    TimeChange(date, { start, end }) {
      if (date) {
        this.searchData[start] = this.time(date[0]);
        this.searchData[end] = this.time(date[1]);
      } else {
        this.searchData[start] = undefined;
        this.searchData[end] = undefined;
      }
    },
            clickrow(val) {
                this.currentRow = val
            },
            handleCurrentChange(val) {
                console.log(val, '页码')
                this.pagenation.pageNo = val
                this.getReportLVist()
            },
            handleSizeChange(val) {
                console.log(val, '条数')
            },
            // 查询表格数据
            getReportLVist() {
              console.log(this.searchData)
              if(!this.searchData.uniqueCode && !this.searchData.qrCode){
                this.info(h_i18n('9a4f5889a1329226c5a3cdeff9ff2ae3'))
                return
              }
                // this.searchData.testTimeStart = this.formatDate(this.searchData.testTimeStart)
                // this.searchData.testTimeEnd = this.formatDate(this.searchData.testTimeEnd)
                // let paramsvalue = {}
                // if (this.dataFrom) {
                // } else {
                //     paramsvalue.vendorCode = this.supplyCode
                //     paramsvalue.modelNo = this.$route.query.name
                // }
                this.loading = true;
                this.$http({
                    method: 'post',
                    url: '/base/onlineprocess/getAllDetails',
                    headers: {'content-type': 'application/json'},
                    data: {
                        ...this.pagenation,
                        //...this.searchData,
                        //...paramsvalue,
                        //testTime:undefined,
                        // prodNo:this.searchData.prodNo || undefined , 
                        // modelNo:this.searchData.modelNo || undefined , 
                        // testTimeStart:this.searchData.testTimeStart || undefined , 
                        // testTimeEnd: this.searchData.testTimeEnd || undefined , 
                        uniqueCode:this.searchData.uniqueCode,
                        qrCode:this.searchData.qrCode,
                        fixConfig:true,
                    },
                }).then((res) => {
                    console.log(res, '查询到的数据')
                    this.loading = false
                    if (res.data.code == 200) {
                        // if (res.data.testOnlineDetailsDTOList) {
                        if (res.data.data.total > 200000) {
                            this.info(h_i18n('ce2400865ddf88aa1b25023099afd61e'), h_i18n('f148292ae0c683ca6fe4246350d309f6'), {
                                confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
                                callback: action => {
                                }
                            })
                            return;
                        }
                        this.tableData = res.data.data.testOnlineDetailsDTOList
                        this.total = res.data.data.total
                        // } else {
                        //     this.tableData = ''
                        //     this.pagenation.page = res.data.pageNum
                        //     this.total = res.data.total
                        // }
                    }else{
                      this.total = 0
                  this.tableData = []
                    }
                }).catch(err=>{
                  this.total = 0
                  this.tableData = []
                })
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num)
            },
            formatDate(a) {
                let date = new Date(a)
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let day = date.getDate()
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day)
            },
            chooseTime() {
                if (this.searchData.testTimeStart !== "") {
                    this.searchData.testTimeStart = this.formatDate(this.searchData.testTimeStart)
                }
                if (this.searchData.testTimeEnd !== "") {
                    this.searchData.testTimeEnd = this.formatDate(this.searchData.testTimeEnd)
                }
                console.log(this.searchData)
            },

            EXportsqm(){
              if(!this.searchData.uniqueCode && !this.searchData.qrCode){
                this.info(h_i18n('e297b1a7803e53ec2de8ed9b3b84ff2a'))
                return
              }
              this.startLoading(h_i18n('1e6d2fe560a665d256b9a2033f9cc22b'))
                    this.exportLoading = true
              if (this.total > 10000) {
                    this.info(h_i18n('5e918af24d6756bed29794c63232a10e'), h_i18n('f148292ae0c683ca6fe4246350d309f6'), {
                        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
                        callback: action => {
                        }
                    })
                } else {
                    this.$http({
                        method: 'post',
                        url: '/base/onlineprocess/sqmexportAllDetailExcel',
                        data: {
                            // name: this.$route.query.name,
                            // ...this.timevalue,
                            // ...this.searchData,
                            // ...paramsvalue,
                            // testTime:undefined,
                            uniqueCode:this.searchData.uniqueCode,
                            qrCode:this.searchData.qrCode,
                            fixConfig:true,
                        },
                        responseType: "blob"
                    }).then((res) => {
                        if (res.status == 200) {
                            let blob = new Blob([res.data], {type: "application/vnd.ms-excel"}); // 文件流
                            let blobUrl = URL.createObjectURL(blob);
                            const link = document.createElement("a"); //模拟a链接，不支持低版本ie

                            link.download = h_i18n('771e8ac38dab52f167d52217b787224c');
                            link.style.display = "none";
                            link.href = blobUrl;
                            document.body.appendChild(link);
                            link.click();
                            URL.revokeObjectURL(link.href);
                            document.body.removeChild(link);
                        }
                    }).catch((err) => {
                        console.log('导出失败',err);
                        this.warning(h_i18n('CEB4728F29B8224B4B0D0F92BA3C54A4'))
                    }).finally(()=>{
                      this.closeLoading();
            this.exportLoading = false
                    })

                }
            },
            
        },
        created(){
          // if (this.$route.query.dataFrom) {
          //       // true = hmqm
          //       this.dataFrom = this.$route.query.dataFrom === "false" ? false : true;
          //   }
        },
        mounted() {
            // if (this.$route.query.dataFrom) {
            //     // true = hmqm
            //     this.dataFrom = this.$route.query.dataFrom === "false" ? false : true;
            //     this.dataFrom && this.getBtn()
            // }
            // if (!this.dataFrom) { // sqm
            //     // this.searchData.testTimeStart = this.formatDate(new Date().getTime() - 24 * 30 * 60 * 60 * 1000)
            //     // this.searchData.testTimeEnd = this.formatDate(new Date().getTime())
            //     // this.searchData.testTime = [this.searchData.testTimeStart,this.searchData.testTimeEnd]
            //     // this.getReportLVist();
            //     // this.name = this.$route.query.name
            //     // this.supplyCode = this.$route.query.name
            // }else{
            //   // window.getItemName = this.$route.query.name
            //   // window.getItemNickName = this.$route.query.nickName

            // }
        },
    }
    if (window.location.search) {
        let search = window.location.search
        window.location.replace("/#/SQMlist" + search)
    }
</script>

<style lang="scss">
.tipBox_yellow {
    padding: 4px 16px;
    border: 1px solid #ffe4ba;
    background-color: #fff7e8;
    border-radius: 6px;
    line-height: 20px;
    height: auto;
    color: #1D2129;
    font-size: 14px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-left: 12px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
.planHidden {
  display: none;
}

.reportTemplateList {
  width: 1150px;
  margin: 0px auto;
  height: auto;
  overflow: visible;
  background: white;
  font-size: 12px;
  padding: 10px;

  .search {
    .searchLable {
      width: 35%;
    }

    .searchContent {
      width: 65%;
    }
  }

  .disableBut {
    color: gray !important;
    cursor: default !important;
  }

  .lable-left {
    margin-top: 0px;
    padding-right: 20px;
    border-bottom: 1px solid #E5E6E7;

    span {
      font-size: 1.5em;
      line-height: 33px;
      color: #333;
    }

    i {
      color: #387CD7;
      padding-right: 10px;
    }
  }
}
</style>